import { TaskCategory } from './types';

export const TASK_CATEGORY_BG_COLORS: Record<TaskCategory, string> = {
  error: 'bg-types-error',
  support: 'bg-types-support',
  request: 'bg-types-request',
  maintenance: 'bg-types-maintenance',
  documentation: 'bg-types-documentation',
} as const;
